import React from 'react';
import { Lightbulb } from 'lucide-react';

const ExplanationBox = ({ title = "Why this recommendation?", children }) => {
  return (
    <div className="explanation-box">
      <div className="explanation-header">
        <Lightbulb size={20} />
        <strong>{title}</strong>
      </div>
      <div className="explanation-content">
        {children}
      </div>
    </div>
  );
};

export default ExplanationBox;
